'use client';
import { MouseEvent } from 'react';
import { notifyMeClicked } from '@repo/ui/src/services/analytics';
import Button from '@repo/ui/src/components/Button';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import { CTAButtonProps, ProductProps } from '@repo/ui/src/types';

interface Props {
  product: ProductProps;
  buttonProps?: CTAButtonProps;
  customProductPrice?: number;
  className?: string;
  onClick?: () => void;
}

const NotifyMeButton = ({
  buttonProps,
  product,
  customProductPrice,
  onClick,
  className,
}: Props) => {
  const { t } = useTranslation();
  const { push } = useModal(ModalID.notifyMe);

  return (
    <Button
      {...buttonProps}
      className={className}
      onClick={(e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClick?.();
        notifyMeClicked({
          category: product?.mainCategory,
          description: product?.description,
          image_url: encodeURI(product.mainImageUrl),
          name: product?.title,
          price: product?.price,
          product_id: product?.sku,
          sku: product?.sku,
          url: window.location.href,
          variant: '', // not available yet
        });
        push({
          product_id: product?.sku,
          name: product?.title,
          price: customProductPrice ?? product.price,
          category: product?.mainCategory,
          image_url: encodeURI(product.mainImageUrl),
          url: product?.productUrl ?? '',
        });
      }}
    >
      {t('notifyMeModalContent.notifyMeLabel', undefined, { default: 'Notify Me' })}
    </Button>
  );
};

export default NotifyMeButton;
